import { render } from "./ProgramView.vue?vue&type=template&id=1edca49d&scoped=true&lang=true"
import script from "./ProgramView.vue?vue&type=script&lang=js"
export * from "./ProgramView.vue?vue&type=script&lang=js"

import "./ProgramView.vue?vue&type=style&index=0&id=1edca49d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1edca49d"]])

export default __exports__